module.exports = __webpack_public_path__ + "static/media/menu_snippet_fj.179e0cc3.png";